import React from "react"
import { MainCP } from "../../Components/Confianza-presidente/MainCP"

const ViewConfianzaPresidente: React.FC = () => <MainCP/>

export default ViewConfianzaPresidente;